import React, { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { ROUTES } from '@/constants'

const HRAgentPage: React.FC = () => {
  // Redirect to conversations page since that's where the HR content now lives
  return <Navigate to={ROUTES.HR_CONVERSATIONS} replace />
}

export default HRAgentPage 